import { isObject, isArray, isNil } from 'lodash/fp';

const hasVehicleParameterFilter = (filter): boolean => {
    if (isObject(filter)) {
        for (const key of Object.keys(filter)) {
            const hasFilter = hasVehicleParameterFilter(filter[key]);

            if (hasFilter) {
                return true;
            }
        }

        // exit loop as there's no match
        return false;
    }

    if (isArray(filter)) {
        return filter?.length > 0;
    }

    return !isNil(filter);
};

export default hasVehicleParameterFilter;
